"use client";
import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

function adjustColorToVariant(options: Map<string, unknown>) {
  if (
    options.get("variant") === "redirect" &&
    options.get("color") === "ghost"
  ) {
    options.set("color", "primary");
    alert(`Redirect variant does not support "ghost" color`);
  }
}

export const ctaInputs = [
  {
    name: "label",
    type: "string",
    defaultValue: "CTA label",
    required: true,
  },
  {
    name: "url",
    type: "url",
    defaultValue: "#ploom",
    required: true,
  },
  {
    name: "variant",
    type: "string",
    enum: ["redirect", "cta"],
    defaultValue: "cta",
    required: true,
    onChange: adjustColorToVariant,
  },
  {
    name: "color",
    type: "string",
    enum: ["primary", "secondary", "tertiary", "quaternary", "ghost"],
    defaultValue: "primary",
    required: true,
    onChange: adjustColorToVariant,
  },
  {
    name: "alignment",
    type: "string",
    enum: ["start", "center", "end"],
    defaultValue: "center",
  },
] as const satisfies Inputs;

export const CtaComponent: RegisteredComponent = {
  name: "CTA",
  component: withValidation(
    ctaInputs,
    dynamic(() => import("./Cta").then((mod) => mod.Cta)),
    "CTA"
  ),
  inputs: ctaInputs,
};
